<template>
  <b-badge v-if="motivo" variant="warning" v-b-tooltip.hover :title="'Este documento foi cancelado: ' + motivo"
    class="mx-1">
    <font-awesome-icon icon="ban" />
    Cancelado
  </b-badge>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

const CompProps = Vue.extend({
  name: 'BadgeCancelamento',
  props: {
    motivo: {
      type: String,
      default: ''
    },
  }
})
@Component
export default class BadgeCancelamento extends mixins(CompProps) {
}
</script>

<style scoped></style>